import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { PeopleAltOutlined as PeopleAltOutlinedIcon } from '@mui/icons-material';

import { campaignsSelectors } from 'store/selectors/campaigns';

import { StatisticTiles } from 'common/components';

import { colors } from 'utils/constants';
import { CardWrapper } from 'globalStyles';

const StatisticWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 40px;
`;

const Title = styled.h2`
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 20px;
`;

const TextActionAlertOverview = () => {
  const { actionAlertRecipients } = useSelector(state => ({
    actionAlertRecipients: campaignsSelectors.getActionAlertRecipients(state),
  }));

  const tiles = useMemo(
    () => [
      {
        count: actionAlertRecipients?.length || 0,
        icon: (
          <PeopleAltOutlinedIcon
            color="blue"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.people,
        name: 'Recipients',
      },
    ],
    [actionAlertRecipients]
  );

  return (
    <CardWrapper>
      <Title>Overview</Title>
      <StatisticWrapper>
        <StatisticTiles tiles={tiles} />
      </StatisticWrapper>
    </CardWrapper>
  );
};

export default TextActionAlertOverview;
